import React from "react";

import serverDownImage from "../logos/serverdown.png";
import noDataImage from "../logos/nodata.png";

import "./CommonDashboard.css";
import "./TableStatus.css";

/**
 * What a dashboard table shows when it has no grid to show.
 *
 * The three states were previously collapsed into two: `errors` starts out
 * true while the first request is still in flight, so every dashboard flashed
 * "service not available" on load. Loading is now its own state, and the two
 * artwork states only appear once the request has actually come back.
 */
/** The Elhi mark, animated, for anywhere a spinner would otherwise go. */
export const BrandLoader = ({ className = "" }) => (
  <div className={`table-status ${className}`.trim()}>
    {/* A div rather than an img: the animation masks a moving highlight
        through the artwork, which needs the mark as a mask, not content. */}
    <div className="table-status-mark" role="img" aria-label="ElhiTech" />
    <span className="table-status-label">Loading…</span>
    <span className="table-status-sr-only" role="status">
      Loading
    </span>
  </div>
);

const TableStatus = ({ loading, errors }) => {
  if (loading) {
    return <BrandLoader />;
  }

  return (
    <div className="error-container">
      {errors ? (
        <div className="error">
          <img className="img1" src={serverDownImage} alt="Service not available" />
        </div>
      ) : (
        <div className="error">
          <img className="img2" src={noDataImage} alt="No entries found" />
        </div>
      )}
    </div>
  );
};

export default TableStatus;
